import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";


export const TranslationLoadGuard: CanActivateFn = (route, state) => {
    var service = inject(TranslateService);

    return new Observable((observer) => {
        service.get("generic.loading").subscribe({
            next: () => {
                observer.next(true);
            },
            error: error => {
                observer.next(false);
                observer.error(error);
            },
            complete: () => {
                observer.complete();
            },
        })
    })
}
